<template>
  <div>
    <b-modal hide-footer centered size="xl" v-model="visible">
      <template #modal-title> Order History </template>
      <data-table :fields="fields" :loading="loading" :items="orderData">
        <template #closePrice="{ data }">
          <span> {{ data.item.closePrice || "-" }} </span>
        </template>
        <template #closeTime="{ data }">
          <span> {{ data.item.closeTime || "-" }} </span>
        </template>
        <template #comment="{ data }">
          <span> {{ data.item.comment || "-" }} </span>
        </template>
        <template #actions="{ data }">
          {{ data.item.actions || "-" }}
        </template>
        <template #commission="{ data }">
          {{ data.item.commission || "-" }}
        </template>
        <template #expiration="{ data }">
          {{ data.item.expiration || "-" }}
        </template>
        <template #lots="{ data }"> {{ data.item.lots || "-" }} </template>
        <template #magicNumber="{ data }">
          {{ data.item.magicNumber || "-" }}
        </template>
        <template #openPrice="{ data }">
          {{ data.item.openPrice || "-" }}
        </template>
        <template #openTime="{ data }">
          {{ data.item.openTime || "-" }}
        </template>
        <template #profit="{ data }"> {{ data.item.profit || "-" }} </template>
        <template #rateClose="{ data }">
          {{ data.item.rateClose || "-" }}
        </template>
        <template #rateMargin="{ data }">
          {{ data.item.rateMargin || "-" }}
        </template>
        <template #rateOpen="{ data }">
          {{ data.item.rateOpen || "-" }}
        </template>
        <template #stopLoss="{ data }">
          {{ data.item.stopLoss || "-" }}
        </template>
        <template #swap="{ data }"> {{ data.item.swap || "-" }} </template>
        <template #symbol="{ data }"> {{ data.item.symbol || "-" }} </template>
        <template #ticket="{ data }"> {{ data.item.ticket || "-" }} </template>
        <template #type="{ data }"> {{ data.item.type || "-" }} </template>
      </data-table>
    </b-modal>
  </div>
</template>

<script>
import { BModal, BFormGroup, BButton, BFormTextarea } from "bootstrap-vue";
import Loader from "@core/components/loader/Loader.vue";
import DataTable from "@/@core/components/data-table/DataTable.vue";
let moment = require("jalali-moment");

export default {
  components: {
    BModal,
    BFormGroup,
    BButton,
    BFormTextarea,
    Loader,
    DataTable,
  },
  props: {
    id: {
      status: Object,
      default: () => {},
    },
    showModal: {
      status: Boolean,
      default: false,
    },
    title: {
      status: String,
      default: " ",
    },
  },
  data() {
    return {
      loading: false,
      orderData: [],
      fields: [
        { key: "closePrice", label: "closePrice" },
        { key: "closeTime", label: "closeTime" },
        { key: "comment", label: "comment" },
        { key: "commission", label: "commission" },
        { key: "expiration", label: "expiration" },
        { key: "lots", label: "lots" },
        { key: "magicNumber", label: "magicNumber" },
        { key: "openPrice", label: "openPrice" },
        { key: "openTime", label: "openTime" },
        { key: "profit", label: "profit" },
        { key: "rateClose", label: "rateClose" },
        { key: "rateMargin", label: "rateMargin" },
        { key: "rateOpen", label: "rateOpen" },
        { key: "stopLoss", label: "stopLoss" },
        { key: "swap", label: "swap" },
        { key: "symbol", label: "symbol" },
        { key: "ticket", label: "ticket" },
        { key: "type", label: "type" },
      ],
    };
  },
  computed: {
    visible: {
      get() {
        return this.showModal;
      },
      set(val) {
        this.$emit("close", val);
      },
    },
  },
  async created() {
    this.loading = true;
    await this.getHistory();
    this.loading = false;
  },
  methods: {
    async getHistory() {
      this.Now = moment().format("YYYY-MM");
      let DayNow = moment().format("YYYY-MM-DD");
      try {
        const params = {
          from: this.Now + `-01`,
          to: DayNow,
        };
        const { data } = await this.$http.get(
          `/panel/accounts/${this.id}/order_histories`,
          {
            params,
          }
        );
        this.orderData = data.data;
      } catch (e) {}
    },
  },
};
</script>

<style scoped>
.btn {
  background-color: #252531;
  border: 1px solid #ffffff0d;
}
@media (min-width: 576px) {
  .modal-dialog {
    width: 560px !important;
  }
}
</style>
